export const cashinOfferStatus = {
    NotAvailable: 'NotAvailable',
    Running: 'Running',
    InProgress: 'InProgress',
    Finished: 'Finished',
    Stopped: 'Stopped'
};
